export default __webpack_public_path__ + "static/media/disputes-icon.1d64a0dc.svg";